<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="part"><a id="page4"></a><a href="#/OEBPS/toc.htm#p01"><strong>I</strong></a></h1>
<h1 class="part1"><a href="#/OEBPS/toc.htm#p01">Scimitar and Son</a></h1>
<p><a id="page5"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?418aac8f